.filterButton {
	padding: 12px 12px !important;
	position: relative;
	height: 42px;
}

.filterButton:focus-visible {
	outline: var(--focus-outline);
}

.closeBtnPlaceholder {
	width: 16px;
	height: 16px;
}

.arrow {
	transition: transform 0.3s ease;
}

.openArrow {
	transform: rotate(180deg);
}
